import { render, staticRenderFns } from "./CardProfits.vue?vue&type=template&id=40bf7832"
import script from "./CardProfits.vue?vue&type=script&lang=js"
export * from "./CardProfits.vue?vue&type=script&lang=js"
import style0 from "./CardProfits.vue?vue&type=style&index=0&id=40bf7832&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports